// Ширина карточки на мобильном устройстве
export const SLIDE_WIDTH = 233;

// Отступы десктопного слайдера
export const DESKTOP_SLIDER_INDENTS = {
  left: 42,
  right: 42,
  beetween: 16,
  bottom: 15,
};

// Отступы мобильного слайдера
export const MOBILE_SLIDER_INDENTS = {
  left: 16,
  right: 16,
  beetween: 16,
  bottom: 15,
};
